const $ = window.jQuery;

import errorManager from '@/rollbar.js';

const startEndDifferenceInMinutes = () => {
  const dateFormat = 'DD/MM/YYYY HH:mm';
  const startDate = document.querySelector('#modal-for-agenda-data-inizio').value;
  const startTime = document.querySelector('#modal-for-agenda-ora-inizio').value;
  const endDate = document.querySelector('#modal-for-agenda-data-fine').value;
  const endTime = document.querySelector('#modal-for-agenda-ora-fine').value;

  const startDateTime = moment(`${startDate} ${startTime}`, dateFormat);
  const endDateTime = moment(`${endDate} ${endTime}`, dateFormat);

  return endDateTime.diff(startDateTime, 'minutes');
};

const validateDuration = (selector, durationSelector, spotActivity) => {
  let duration = document.querySelector(durationSelector);
  let alertActivityDuration = $(selector).data('alert-activity-duration');
  let alertActivityDurationHours = $(selector).data('alert-activity-duration-hour');
  alertActivityDurationHours = alertActivityDurationHours && alertActivityDurationHours > 0 ? alertActivityDurationHours : 6;

  let durationValue;
  if (spotActivity) {
    durationValue = startEndDifferenceInMinutes();
  } else if (duration) {
    durationValue = duration.value;
  } else {
    durationValue = null;
  }

  if (alertActivityDuration && durationValue && Number(durationValue) > alertActivityDurationHours * 60) {
    return confirm(`Stai per salvare una attività di più di ${alertActivityDurationHours} ore, vuoi continuare?`);
  }
  return true;
};

const disableAndSave = (selector, saveAndRegister) => {
  document.getElementById('guest_activity_domestic_save_and_register').value = saveAndRegister;
  saveAction(selector);
};

const savePlanAndRegister = (selector) => {
  let justClickedAndPending = false;

  $(document).on('click', selector, function () {
    let motivationRequired = $(selector).data('disablemotivation');
    if (motivationRequired) {
      return $(selector).attr('disabled', 'disabled');
    }

    let repeatsEndOn;
    if (justClickedAndPending) {
      return true;
    }
    $(selector).attr('disabled', 'disabled');
    justClickedAndPending = true;
    repeatsEndOn = document.getElementById('repeats_end_on');
    if (repeatsEndOn && repeatsEndOn.value) {
      if (validateDuration(selector, '#js-duration-std', false)) {
        disableAndSave(this, true);
      } else {
        justClickedAndPending = false;
        $(selector).removeAttr('disabled');
        return false;
      }
    } else {
      alert('Data di fine mancante!');
    }
    justClickedAndPending = false;
    return $(selector).removeAttr('disabled');
  });
};

const savePlan = () => {
  $(document).on('click', 'a.save-guest-activity', function () {
    let closeActivity = document.querySelector('.js-close-activity');
    let spotActivitySelector = document.querySelector('#input_spot_activity');
    let spotActivity = spotActivitySelector?.value == 'true';

    if ((closeActivity && closeActivity.checked) || spotActivity) {
      if (validateDuration(this, '#js-duration-std-modal-agenda', spotActivity)) {
        disableAndSave(this, false);
      } else {
        return false;
      }
    } else {
      disableAndSave(this, false);
    }
  });
};

const saveAction = (target) => {
  let valResult = selectProfileValidation();

  if (!valResult) return false;

  var date_in, fine_periodo, fine_plan, form, periodo, url;
  periodo = $('#nrgg_label').html();
  date_in = $('#datein_label').data('date_in');
  fine_periodo = moment(date_in).add(periodo, 'days').format('DD/MM/YYYY');
  fine_plan = $('#repeats_end_on').val();
  form = $(target).parents('form');
  url = form.data('url-control');
  url += '?from_domestic=true&' + form.serialize();
  let newUrl = deleteSubActivitiesFromUrl(url);
  return $.ajax({
    url: newUrl,
    beforeSend: function () {
      return Loader.show();
    },
    success: function (data) {
      let message;
      message = '';
      $.each(data['users'], function (i, v) {
        return (message += '<li>' + v[0] + ' sarà assente dal ' + v[1] + ' al ' + v[2] + '</li>');
      });
      $('#modal-confirm .modal-body .users-list').html(message);
      if (message.length <= 0) {
        Loader.hide();
        if (periodo === 'periodo non impostato') {
          return form.submit();
        } else {
          if (fine_plan > fine_periodo) {
            if (confirm("La pianificazione va oltre il periodo previsto per l'utente, continuare comunque?")) {
              return form.submit();
            }
          } else {
            return form.submit();
          }
        }
      } else {
        $('#submit-form-agenda').data('form', form.prop('id'));
        $('#modal-confirm').modal('show');
        return Loader.hide();
      }
    },
    error: function () {
      return Loader.hide();
    },
  });
};

const selectProfileValidation = () => {
  let profileSelectContainer = document.querySelector('.agenda_plan_new_activity_profile_select_container');

  if (profileSelectContainer && !profileSelectContainer.classList.contains('not-clickable')) {
    let profiloCuraInput = document.querySelector('#profilo_cura_input');

    if (!profiloCuraInput.value) {
      alert('Indicare il Profilo');

      return false;
    }
  }

  return true;
};

const deleteSubActivitiesFromUrl = (url) => {
  var parts = url.split('?');
  var baseUrl = parts[0];
  var queryString = parts[1];
  let updatedUrl = '';
  if (queryString) {
    var params = queryString.split('&');
    var filteredParams = params.filter(function (param) {
      return !param.includes('sub_activities');
    });
    updatedUrl = baseUrl + '?' + filteredParams.join('&');
  } else {
    updatedUrl = url;
  }
  return updatedUrl;
};

const init = () => {
  try {
    console.log('Ho inizializzato le funzioni di salvataggio!');
    savePlanAndRegister('#save-and-register');
    savePlan();
  } catch (e) {
    errorManager(e);
  }
};

window.CalendarFormModal = {
  init: init,
};
